/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Tab, Table, Tabs, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CommonApiService from '../../../services/CommonApiService';
import { useD2Approval } from './ContextAPI';
import ShowTable from './ShowTable';
import { convertArrayOfObjectsToCSV4d2 } from '../../../Utils';
import LoaderSubmit from '../../LoaderSubmit';
import SweetAlertService from '../../../services/SweetAlertService';

export default function ShowModel() {
    const {
        show,
        setShow,
        rowData,
        addD2Approval,
        receiveData,
        setReceiveData,
        receiveList,
        // setReceiveList,
        isSubmitted,
        setIsSubmitted,
    } = useD2Approval();
    const { drugCategory, getDrugCategory } = CommonApiService();
    const { submitConfirmSwal } = SweetAlertService();
    const [page, setPage] = useState(0);
    const [pageLength, setPageLength] = useState(0);

    useEffect(() => {
        rowData?.records?.map((el) => {
            const itemdata = {};
            itemdata.drug_id = el.drug_id;
            itemdata.d2_details_id = el.d2_details_id;
            itemdata.requested_qty = el.requested_qty;
            itemdata.approved_request_qty =
                el.approved_request_qty > 0 ? el.approved_request_qty : el.requested_qty;

            const list = receiveData;
            list[itemdata.drug_id] = itemdata;
            if (itemdata.drug_id === '') {
                delete list[itemdata.drug_id];
            }

            setReceiveData(list);

            // const arrOfObj = toArray(list);
            // setReceiveList(arrOfObj);
            return receiveData;
        });
    }, [rowData.records]);

    const dataList = useCallback(() => {
        getDrugCategory(); //  Drug Category
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        setPageLength(drugCategory?.length);
    }, [drugCategory]);

    // Closing the Model
    const handleClose = () => {
        setShow(false);
    };

    const tableDataDisplay = () =>
        drugCategory?.map((item, index) => (
            <Tab key={item.id} eventKey={index} title={item.name}>
                <ShowTable data={rowData?.records?.filter((el) => el.category_id == item.id)} />
            </Tab>
        ));

    const submitHandler = async () => {
        const isConfirmed = await submitConfirmSwal({
            title: 'Do you want to submit this approval?',
            text: 'Please confirm to continue.',
            confirmButtonText: 'Submit',
            denyButtonText: "Don't submit",
            cancelButtonText: 'Cancel',
        });

        if (!isConfirmed) return;

        setIsSubmitted(true);
        const data = {
            d2_master_id: rowData.d2_master_id,
            medicine_lists: receiveList,
        };
        addD2Approval(data);
    };

    function downloadCSV() {
        const search_column = {
            drug_name: 'Item Names',
            requested_qty: 'Request Quantity',
            approved_request_qty: 'Approved Request Quantity',
            approved_qty: 'Approved Quantity',
            approved_supply_qty: 'Supplied Quantity',
        };
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV4d2(
            search_column,
            rowData,
            rowData?.partner_name,
            drugCategory
        );
        if (csv == null) return;
        const filename = `d2 - ${rowData?.partner_name}.csv`;
        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }

    // eslint-disable-next-line react/no-unstable-nested-components
    function Export({ onClick }) {
        return (
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-download-d2approval">Download</Tooltip>}>
                <Button
                    className="btn btn-light downloadCsvBtn"
                    onClick={(e) => onClick(e.target.value)}
                >
                    <i className="fa fa-download" />
                </Button>
            </OverlayTrigger>
        );
    }

    return (
        <Modal className="modalWidth80" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Partner Internal Request Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col>
                            <Col className="mb-4 text-end downloadCSV">
                                <Export onClick={() => downloadCSV()} />
                            </Col>
                            <Table bordered hover size="sm">
                                <thead className="table-light">
                                    <tr>
                                        <th>Partner Name</th>
                                        <th>Month</th>
                                        <th>Year</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{rowData?.partner_name}</td>
                                        <td>
                                            {rowData?.month == 1
                                                ? 'January'
                                                : rowData?.month == 2
                                                    ? 'February'
                                                    : rowData?.month == 3
                                                        ? 'March'
                                                        : rowData?.month == 4
                                                            ? 'April'
                                                            : rowData?.month == 5
                                                                ? 'May'
                                                                : rowData?.month == 6
                                                                    ? 'June'
                                                                    : rowData?.month == 7
                                                                        ? 'July'
                                                                        : rowData?.month == 8
                                                                            ? 'August'
                                                                            : rowData?.month == 9
                                                                                ? 'September'
                                                                                : rowData?.month == 10
                                                                                    ? 'October'
                                                                                    : rowData?.month == 11
                                                                                        ? 'November'
                                                                                        : rowData?.month == 12
                                                                                            ? 'December'
                                                                                            : ''}
                                        </td>
                                        <td>{rowData?.year}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Tabs
                            activeKey={page}
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                            // eslint-disable-next-line radix
                            onSelect={(k) => setPage(parseInt(k))}
                        >
                            {tableDataDisplay()}
                        </Tabs>
                    </Row>

                    <Modal.Footer className="borderTop0 pe-0">
                        <Button className="btnCancel" variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        {page !== 0 && (
                            <Button
                                className="btnInfo me-2 ms-2"
                                variant="primary"
                                style={{ minWidth: '6rem' }}
                                disabled={page === 0}
                                onClick={() => {
                                    setPage((currPage) => currPage - 1);
                                }}
                            >
                                Prev
                            </Button>
                        )}
                        <Button
                            type="button"
                            // className={`btnSuccess ${
                            //     rowData.status === 'd2_prepared' &&
                            //     page === pageLength - 1 &&
                            //     'd-none'
                            // }`}
                            className={`btnSuccess ${page === pageLength - 1 && 'd-none'}`}
                            variant="success"
                            disabled={page === pageLength - 1}
                            style={{ minWidth: '6rem' }}
                            onClick={() => setPage((currPage) => currPage + 1)}
                        >
                            Next
                        </Button>
                        {/* {rowData.status === 'd2_prepared' && (
                                                )} */}
                        <Button
                            onClick={submitHandler}
                            className={`btnSuccess ${page !== pageLength - 1 && 'd-none'}`}
                            type="button"
                            variant="success"
                            style={{ minWidth: '6rem' }}
                            disabled={isSubmitted}
                        >
                            Submit
                        </Button>
                        {isSubmitted && <LoaderSubmit />}
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
